export const NUXT_STATE_KEY = "i18n";
export const COOKIE_LANGUAGE = "BM_lang";
